<template>
  <div :class="$style.cashbackVip">
    <picture :class="$style.cashbackVipBanner">
      <source media="(max-width: 1200px)" :srcset="urlBannerTablet" />
      <img :src="urlBanner" alt="cashbackVip" />
    </picture>
    <div :class="$style.cashbackVipTitle">
      {{ title }}
    </div>
    <BannerCalendar
      :class="$style.topSliderCalendar"
      :default-icon="false"
      :end-date="endDate"
      :start-date="startDate"
    />
    <Markdown :text="textMarkdown" />

    <BitButton
      :class="$style.vipButtonFever"
      type="secondary"
      width-size="md"
      :no-margin="true"
      :is-fluid-width="true"
      @click="openDepositOrSignupModal"
    >
      {{ buttonTitle }}
    </BitButton>
    <div ref="wrapper" :class="$style.cashbackCardWrapper">
      <BitCashbackCard
        v-for="card in cardData"
        :key="card.id"
        :class="[
          $style.cashbackCardLength,
          { [$style.cashbackCardLength4]: cardData.length === 4 },
          { [$style.cashbackCardLength5]: cardData.length === 5 },
          { [$style.cashbackCardLength6]: cardData.length === 6 },
          { [$style.cashbackCardLength7]: cardData.length === 7 },
          { [$style.cashbackCardLength8]: cardData.length === 8 },
        ]"
        :title-number="card.titleNumber"
        :text-min-deposit="card.textMinDeposit"
        :number-min-deposit="snippet.format(card.numberMinDeposit)"
        :text-min-loss="card.textMinLoss"
        :number-min-loss="snippet.format(card.numberMinLoss)"
        :wager="card.wager"
        :number-wager="card.numberWager"
      />
    </div>
    <div :class="$style.cashbackVipTerms" @click="termsLink">{{ terms }}</div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton, BitCashbackCard } from '@bit/ui-kit';
import BannerCalendar from '~/components/lib/mainPage/mainBanner/bannerCalendar/bannerCalendar.vue';
import Markdown from '~/components/markdown.vue';
import { useSnippet } from '~/composables/useSnippet';
import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { EModalName } from '~/types/modals';

defineProps({
  urlBanner: {
    type: String,
    default: '',
  },
  urlBannerTablet: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  endDate: {
    type: String,
    default: '',
  },
  startDate: {
    type: String,
    default: '',
  },
  textMarkdown: {
    type: String,
    default: '',
  },
  buttonTitle: {
    type: String,
    default: '',
  },
  cardData: {
    type: [Array, Object],
    default: () => [],
  },
  terms: {
    type: String,
    default: '',
  },
});

const router = useRouter();
const snippet = useSnippet();
const storeRoot = useStoreRoot();
const storeModals = useStoreModals();
const storeSsPlayer = useStoreSsPlayer();

const termsLink = () => {
  router.push({
    path: storeRoot.domainLang
      ? `/${storeRoot.domainLang}/terms-and-conditions`
      : '/terms-and-conditions',
  });
};
const openDepositOrSignupModal = () => {
  if (storeSsPlayer.isPlayerAuthorised) {
    storeModals.openModal(EModalName.deposit, {
      gtmParams: { button_place: 'vip_page_cashback_fever' },
    });
  } else {
    storeModals.openModal(EModalName.signup, {
      gtmParams: { button_place: 'vip_page_cashback_fever' },
    });
  }
};
</script>

<style lang="scss" module src="./cashbackFever.scss"></style>
